import React, { useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { useAuthStore } from  '../store/store'
import { generateOTP, verifyOTP } from '../helper/helper';
import { useNavigate } from 'react-router-dom'

export default function Recovery() {

  const { username } = useAuthStore(state => state.auth);
  const [OTP, setOTP] = useState();
  const navigate = useNavigate()

  // useEffect(() => {
  //   generateOTP(username).then((OTP) => {
  //     console.log(OTP)
  //     if(OTP) return toast.success('OTP has been send to your email!');
  //     return toast.error('Problem while generating OTP!')
  //   })
  // }, [username]);

  async function onSubmit(e){
    e.preventDefault();
    try {
      let { status } = await verifyOTP({ username, code : OTP })
      if(status === 201){
        toast.success('Verify Successfully!')
        return navigate('/reset')
      }  
    } catch (error) {
      return toast.error('Wront OTP! Check email again!')
    }
  }

  // handler of resend OTP
  function resendOTP(){

    let sentPromise = generateOTP(username);

    toast.promise(sentPromise ,
      {
        loading: 'Sending...',
        success: <b>OTP has been send to your email!</b>,
        error: <b>Could not Send it!</b>,
      }
    );

    sentPromise.then((OTP) => {
      console.log(OTP)
    });
    
  }

  return (
    <div className="recovery-container mx-auto">

    <div className="gradient2"></div>
      <Toaster position='top-center' reverseOrder={false}></Toaster>

      <div className='username-wrapper flex justify-center items-center h-screen'>
        <div className="profile-content">

          <div style={{marginBottom:"20px"}} >
            <h4 style={{fontSize:"30px",marginBottom:"10px"}}>Recovery</h4>
            <span  >
                Enter OTP to recover password.
            </span>
          </div>

          <form className='profile-form' onSubmit={onSubmit}>

              <div className="textbox flex flex-col items-center gap-6">

                  <div className="textbox">
                    <span >
                      Enter 6 digit OTP sent to your email address.
                    </span>
                    <input onChange={(e) => setOTP(e.target.value) } className="profileInput" type="text" placeholder='OTP' />
                  </div>

                  <button className="usernameButton" type='submit' style={{marginBottom:"5px"}}>Recover</button>
              </div>
          </form>

          <div className="text-center py-4" style={{marginBottom:"10px"}} >
            <span  >Can't get OTP? 
            </span>
          </div>
            <button onClick={resendOTP} className='text-red-500'>Resend</button>

        </div>
      </div>
    </div>
  )
}